import Home from "./pages/home";
// import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';

function App() {
  return (
    <div className="App">
    <Home/>
    </div>
  );
}

export default App;
